import { render, staticRenderFns } from "./Insider.vue?vue&type=template&id=8a85c03a&scoped=true&"
import script from "./Insider.vue?vue&type=script&lang=js&"
export * from "./Insider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a85c03a",
  null
  
)

export default component.exports